import { render, staticRenderFns } from "./IndexShop.vue?vue&type=template&id=5188a44a&scoped=true&"
import script from "./IndexShop.vue?vue&type=script&lang=js&"
export * from "./IndexShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188a44a",
  null
  
)

export default component.exports